// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnDownload_btn__00Lbm"};